let config = {
    title: `Demon Slayer: Hashira Training`,
    copyright: '© 2024 Yunnan Zhouqin Network Technology Co., Ltd',
    policy: 'https://demonslayerhashiratraining.com/privacy_policy.html',
    term: 'https://demonslayerhashiratraining.com/terms.html',
    introduceTitle: [
        `Start from the basics and gradually master various combat techniques and strategies through systematic training and practical exercises to enhance your fighting power. The game’s rich tasks and dynamic challenges will test your adaptability and combat wisdom, making you more adept at facing powerful enemies.`,
    ],
    introduceText: [
        {
            title: 'Diverse Combat Experience',
            text: [
                'Face various powerful enemies and use different tactics and skills to defeat them. Master advanced tactics and skill combinations to improve your combat efficiency.'
            ]
        },
        {
            title: 'Stunning Visuals and Sound Effects',
            text: [
                'Enjoy high-definition graphics, detailed character designs, smooth action performance, and immersive sound effects that enhance the combat experience.'
            ]
        },
        {
            title: 'Rich Tasks and Challenges',
            text: [
                'The game includes numerous main and side quests, offering substantial rewards upon completion.'
            ]
        },
        {
            title: 'Social Interaction Features',
            text: [
                'Interact with other players through the in-game social system, exchange battle strategies and experiences, form teams, and tackle high-difficulty tasks and challenges together.'
            ]
        }
    ]
}
export default config;